import { newsApi } from '@features/news/api/newsApi'
import { NEWS_ROUTES } from '@features/news/constants'

/**
 * Загружает новость текущего route и формирует breadcrumbs.
 *
 * @returns реактивная новость и breadcrumbs страницы
 */
export const useNewsDetailPage = async () => {
  const route = useRoute()

  const { data: news, error } = await newsApi.getBySlug(
    String(route.params.slug),
  )

  if (error.value) {
    showError(error.value)
  }

  const breadcrumbs = computed(() => [
    { text: 'Новости', href: NEWS_ROUTES.list },
    {
      text: news.value?.title ?? '',
      href: news.value?.slug
        ? NEWS_ROUTES.detail(news.value.slug)
        : NEWS_ROUTES.list,
    },
  ])

  return {
    news,
    breadcrumbs,
  }
}
